<template>
    <b-modal v-model="modalAberto" :title="title" header-bg-variant="secondary" header-text-variant="light"
        @hide="closeModal" centered>
        <b-container>
            <div v-if="tableBusy" class="d-flex justify-content-center m-3">
                <b-spinner class="m-1 text-center" />
            </div>
            <ol v-else>
                <b-row v-for="item in items" :key="item.message">
                    <b-col class="mt-1" cols="12">
                        <li>{{ item }}</li>
                    </b-col>
                </b-row>
            </ol>
        </b-container>
        <template #modal-footer>
            <b-button size="sm" variant="secondary" @click="closeModal">Fechar</b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

@Component({
    components: {
        ValidationObserver,
        DefaultFormValidationProvider
    },
})
export default class ModalPendencias extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) edital!: any;
    modalAberto = true
    items: any[] = []
    tableBusy = false

    get title(): string {
        return `Pendências do Edital Nº ${this.edital.NrEdital} / Ano ${this.edital.AnoEdital}`
    }

    async created() {
        await this.getPendencias()
    }

    async getPendencias() {
        try {
            this.tableBusy = true
            this.items = await concursoService.getPendencias(this.edital.IdEdital)
            if (this.items.length < 1) {
                this.$toast.info('Não há mais pendências!')
                this.closeModal()
            }
        } catch (error: any) {
            this.tratarError(error)
            this.items = ['Erro ao obter pendências']
        } finally {
            this.tableBusy = false
        }
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>